import { useQuery } from 'react-query'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'
import { errorAlert } from '../../../../utils/alert'
import { Item__Patrimonio } from '../../GET'

export type AtribuicaoFrota = {
    cod: number
    cod_usuario: number
    cod_veiculo: number
    usuario_nome: string
    veiculo_nome: string
    frota: string
}

type Item = {
    cod: number
    nome: string
    cod_tipo: number
    categoria: {
        cod: number
        nome: string
    }
}

interface Data {
    itens: AtribuicaoFrota[]
    total: number
}

interface CategoriaPatrimonio {
    itens: Item__Patrimonio[]
}

export const useGetAtribuicaoFrota = (pagination = 15, page = 1, nome?: string) => {
    const queryKey: any = [`/usuario/veiculo`]

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Data, Error>(
        queryKey,
        async () => {
            return api
                .get(
                    `/usuario/veiculo?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente
                    }&pagination=${pagination}&page=${page}&nome=${nome}`
                )
                .then((response): any => {
                    return response.data
                })
                .catch((error) => {
                    errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de atribuição!')
                })
        },
        {
            enabled: false,
            refetchOnWindowFocus: false,
        }
    )

    return {
        data_atribuicao: data,
        carregando_atribuicao: isFetching,
        refetch_data_atribuicao: refetch,
        isFetched: isFetchedAfterMount,
        isError: isError,
    }
}

export const useGetCategoriaPatrimonio = (pagination = -1) => {
    const queryKey: any = [`/patrimonio`]

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
        CategoriaPatrimonio,
        Error
    >(
        queryKey,
        async () => {
            return api
                .get(
                    `/patrimonio?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente
                    }&pagination=${pagination}&codCategoriaIn=224,26,223,2`
                )
                .then((response): any => {
                    return response.data
                })
                .catch((error) => {
                    errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de veículos!')
                })
        },
        {
            enabled: false,
            refetchOnWindowFocus: false,
        }
    )

    return {
        data_categoria_patrimonio: data,
        carregando_categoria_patrimonio: isFetching,
        refetch_data_categoria_patrimonio: refetch,
        isFetched: isFetchedAfterMount,
        isError: isError,
    }
}